import {
    Component,
    OnInit
} from '@angular/core';
import {
    Constants
} from '../Services/Constants';
import {
    HTTPService
} from '../Services/http.service';
import {
    Observable
} from 'rxjs/Observable';
import {
    filter
} from '../App/search.pipe';
import {
    DatePipe
} from "@angular/common";
import {
    MySharedService
} from '../App/shared.service'

@Component({
    templateUrl: './AppViews/Location/location.html'
})

export class locationComponent implements OnInit {

    constants: Constants;
    isAdd: boolean = true;
    customerLocationListItems: any = [];
    userDetail: any;
    selfuser: boolean = true;
    filter: any = {
        'CustomerId': 0,
        'CustomerLocationId': ""
    };
    Search: any = "";
    active = true;
    public showLoader = false;
    projectFilterFlag: any;
    getProjectUrl: any;
    showcomments: boolean = false;
    getCustomerLocationUrl: any;
    customerList: any = [];
    cityData: any = [];
    filteredCityList: any = [];
    stateData: any = [];
    addCustomerLocationData: any = {

    };
    editCustomerLocationData: any = {
        editCustomerLocationCustomerName: "",
        editCustomerLocationCustomerId: "",
        editCustomerLocationId: "",
        editCustomerLocationName: "",
        editCustomerLocationCode: "",
        editCustomerLocationAddress: "",
        editCustomerLocationCityName: "",
        editCustomerLocationCityId: "",
        editCustomerLocationPinCode: "",
        editCustomerLocationStateName: "",
        editCustomerLocationStateId: "",
        editCustomerLocationContactPerson: "",
        editCustomerLocationDesignation: "",
        editCustomerLocationContactNumber: "",
        editCustomerLocationEmail: ""
    };
    isCustomerLocationFormSubmitted: boolean = false;
    reportFile: any;
    isAddCityFormSubmitted: boolean = false;
    addCityData: any = {
        CityId: 0,
        CityName: "",
        StateId: ""
    };
    cityExists: boolean;

    constructor(private _httpService: HTTPService, private _sharedService: MySharedService, private _datepipe: DatePipe) {
        this.constants = new Constants();
        this.userDetail = JSON.parse(localStorage.getItem("userDetail"));
        this.filter.StatusId = this.constants.enumProjectStatus["Open"];
        this.filter.TeamId = "";
        this.projectFilterFlag = JSON.parse(localStorage.getItem('ProjectFilters'));
        this.getCustomerLocationUrl = "CustomerLocation/GetCustomerLocation"
    }

    ngOnInit() {
        this.GetLocationList(true);
        this.GetCustomerList();
        this.GetCityData();
        this.GetStateData();
    }

    GetCityData() {
        this._httpService.ajaxPost('Common/GetCity').subscribe(
            data => {
                this.cityData = data["Cities"];
            },
            err => {
                console.log("GetCityData Failed with status: " + err.status);
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constants.globalError);
            },
            () => {
                this.showLoader = false;
            }
        );
        setTimeout(function () {
            $(".pop-comment").popover({
                //content: 'test'
                content: function () {
                    return $(this).parent().find('p').html();
                }
            });
        }, 500);
    }

    GetStateData() {
        this._httpService.ajaxPost('Common/GetState').subscribe(
            data => {
                this.stateData = data["States"];
            },
            err => {
                console.log("GetStateData Failed with status: " + err.status);
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constants.globalError);
            },
            () => {
                this.showLoader = false;
            }
        );
        setTimeout(function () {
            $(".pop-comment").popover({
                //content: 'test'
                content: function () {
                    return $(this).parent().find('p').html();
                }
            });
        }, 500);
    }

    GetLocationList(flag: boolean) {
        this.selfuser = flag;
        var UserId = 0;
        var TeamId = 0;
        if (this.userDetail.RoleId != 0) {
            UserId = this.userDetail.SiteUserId;
            //TeamId = this.userDetail.TeamID;
        }
        if (this.filter.TeamId == "") {
            //to handle executives case
            //  if(this.userDetail.RoleId==3){
            TeamId = 0
            //  }else{
            //     TeamId = this.userDetail.TeamID;
            //  }
        } else {
            TeamId = this.filter.TeamId;
        }
        this.showLoader = true;
        this._httpService.ajaxPost(this.getCustomerLocationUrl, {
            "CustomerLocationId": 0,
            "CustomerId": this.filter.CustomerId
        }).subscribe(
            data => {
                this.customerLocationListItems = data["CustomerLocationList"];
            },
            err => {
                console.log("GetLocationList Failed with status: " + err.status);
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constants.globalError);
            },
            () => {
                console.log("GetLocationList " + this.selfuser);
                console.log(this.customerLocationListItems[0]);
                this.showLoader = false;
            }
        );
        setTimeout(function () {
            $(".pop-comment").popover({
                //content: 'test'
                content: function () {
                    return $(this).parent().find('p').html();
                }
            });
        }, 500);
    }

    GetCustomerList() {
        this._httpService.ajaxPost('Customer/GetCustomer', {
            "CustomerId": 0,
            "CountryId": 0,
            "CustomerStatus": true
        }).subscribe(
            data => {
                this.customerList = data["CustomerList"];
            },
            err => {
                console.log("GetCustomerList Failed with status: " + err.status);
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constants.globalError);
            },
            () => {
                this.showLoader = false;
                // console.log(this.customerList);
            }
        );
        setTimeout(function () {
            $(".pop-comment").popover({
                //content: 'test'
                content: function () {
                    return $(this).parent().find('p').html();
                }
            });
        }, 500);
    }

    public clearFilter() {
        this.filter.CustomerId = 0;
        this.filter.CustomerLocationId = 0;
        this.Search = "";

        setTimeout(function () {
            $(".pop-comment").popover({
                //content: 'test'
                content: function () {
                    return $(this).parent().find('p').html();
                }
            });
        }, 500);
    }

    public EditCustomerLocation(item: any) {
        // $('#resetEditCustomerLocationForm').trigger('click');
        this.isAdd = false;

        this.EditCustomerLocationChange(item.CustomerLocationId);
    }

    public DeleteCustomerLocationChange(item: any) {
        // console.log(item);
        this.deleteCustomerLocation(item.CustomerLocationId);
    }


    public EditCustomerLocationChange(itemId: any) {
        let objItem: any = {};
        objItem = JSON.parse(JSON.stringify(this.customerLocationListItems.filter((location) => location.CustomerLocationId == itemId)[0]));
        this.editCustomerLocationData.editCustomerLocationCustomerName = objItem.CustomerName;
        this.editCustomerLocationData.editCustomerLocationCustomerId = objItem.CustomerId;
        this.editCustomerLocationData.editCustomerLocationId = objItem.CustomerLocationId;
        this.editCustomerLocationData.editCustomerLocationName = objItem.LocationName;
        this.editCustomerLocationData.editCustomerLocationCode = objItem.LocationCode;
        this.editCustomerLocationData.editCustomerLocationAddress = objItem.Address;
        // this.editCustomerLocationData.editCustomerLocationCityName = objItem.CityName;
        this.editCustomerLocationData.editCustomerLocationCityId = objItem.CityId;
        this.editCustomerLocationData.editCustomerLocationPinCode = objItem.Pincode;
        // this.editCustomerLocationData.editCustomerLocationStateName = objItem.StateName;
        this.editCustomerLocationData.editCustomerLocationStateId = objItem.StateId;
        this.editCustomerLocationData.editCustomerLocationContactPerson = objItem.ContactPerson;
        this.editCustomerLocationData.editCustomerLocationDesignation = objItem.Designation;
        this.editCustomerLocationData.editCustomerLocationContactNumber = objItem.ContactNumber;
        this.editCustomerLocationData.editCustomerLocationEmail = objItem.Email;
        // console.log(this.editCustomerLocationData); 
    }

    public deleteCustomerLocation(itemId: any) {
        this.showLoader = true;
        console.log(itemId);
        this._httpService.ajaxPost('CustomerLocation/DeleteCustomerLocation', {
            "CustomerLocationId": itemId
        }).subscribe(
            data => {

                var msg = data["Status"].Message.split('|');
                if (msg.length > 1) {
                    msg[0] = msg[0].toLowerCase();
                    this._sharedService.ShowMessage(data["Status"].Message);
                } else {
                    this._sharedService.ShowMessage(data["Status"].Message);
                }
                // this.GetCustomerList();
            },
            err => {
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constants.globalError);

            },

            () => {
                this.showLoader = false;
                this.GetLocationList(false);

            }
        );
    }

    public CancelEditCustomerLocation() {
        this.editCustomerLocationData = {};
        $('#editCustomer').modal('hide');
        this.isAdd = true;
    }

    public UpdateCustomerLocation(form ? : any) {
        this.isCustomerLocationFormSubmitted = true;

        if (form.form.valid) {
            let objItem: any = {};
            objItem.CustomerId = this.editCustomerLocationData.editCustomerLocationCustomerId;
            objItem.CustomerLocationId = this.editCustomerLocationData.editCustomerLocationId;
            objItem.LocationName = this.editCustomerLocationData.editCustomerLocationName;
            objItem.LocationCode = this.editCustomerLocationData.editCustomerLocationCode;
            objItem.Address = this.editCustomerLocationData.editCustomerLocationAddress;
            objItem.CityId = this.editCustomerLocationData.editCustomerLocationCityId;
            objItem.PinCode = this.editCustomerLocationData.editCustomerLocationPinCode;
            objItem.StateId = this.editCustomerLocationData.editCustomerLocationStateId;
            objItem.ContactPerson = this.editCustomerLocationData.editCustomerLocationContactPerson;
            objItem.Designation = this.editCustomerLocationData.editCustomerLocationDesignation;
            objItem.PhoneNumber = this.editCustomerLocationData.editCustomerLocationContactNumber;
            objItem.Email = this.editCustomerLocationData.editCustomerLocationEmail

            this.addEditCustomerLocationData(objItem);

            this.isAdd = true;
        }
    }

    public ResetCustomerLocationForm(form: any) {
        form.reset();
        form.resetForm();
        setTimeout(() => {
            this.addCustomerLocationData.addCustomerLocationCustomerId = "";
            this.addCustomerLocationData.addCustomerLocationCityId = "";
            this.addCustomerLocationData.addCustomerLocationStateId = "";

            this.editCustomerLocationData.editCustomerLocationCustomerId = "";
            this.editCustomerLocationData.editCustomerLocationCityId = "";
            this.editCustomerLocationData.editCustomerLocationStateId = "";
        }, 0);

        this.isCustomerLocationFormSubmitted = false;
    }

    addEditCustomerLocationData(objItem) {
        this.showLoader = true;
        this._httpService.ajaxPost('CustomerLocation/AddUpdateCustomerLocation', objItem)
            .subscribe(
                data => {

                    var msg = data["Status"].Message.split('|');
                    if (msg.length > 1) {
                        msg[0] = msg[0].toLowerCase();
                        this._sharedService.ShowMessage(data["Status"].Message);
                    } else {
                        this._sharedService.ShowMessage(data["Status"].Message);
                    }

                    if (msg[0] == "success") {
                        $('#editCustomerLocation').modal('hide');
                        $('#addCustomerLocation').modal('hide');
                        this.GetLocationList(false);
                        // this.GetCustomerList();
                    }
                },
                err => {
                    this.showLoader = false;
                    this._sharedService.ShowMessage(this.constants.globalError);

                },

                () => {
                    this.showLoader = false;



                }
            );
    }

    public AddCustomerLocationFormLoad() {
        $('#resetAddCustomerLocationForm').trigger('click');
    }

    public CancelAddCustomerLocation(form: any) {
        this.addCustomerLocationData = {};
        $('#addCustomerLocation').modal('hide');
        this.isAdd = true;
    }

    public AddCustomerLocation(form ? : any) {
        this.isCustomerLocationFormSubmitted = true;

        if (form.form.valid) {
            let objItem: any = {};
            objItem.CustomerId = this.addCustomerLocationData.addCustomerLocationCustomerId;
            objItem.CustomerLocationId = null;
            objItem.LocationName = this.addCustomerLocationData.addCustomerLocationName;
            objItem.LocationCode = this.addCustomerLocationData.addCustomerLocationCode;
            if (this.addCustomerLocationData.addCustomerLocationAddress) objItem.Address = this.addCustomerLocationData.addCustomerLocationAddress;
            else objItem.Address = null;
            objItem.CityId = this.addCustomerLocationData.addCustomerLocationCityId;
            if (this.addCustomerLocationData.addCustomerLocationPinCode) objItem.PinCode = this.addCustomerLocationData.addCustomerLocationPinCode;
            else objItem.PinCode = null;
            objItem.StateId = this.addCustomerLocationData.addCustomerLocationStateId;
            if (this.addCustomerLocationData.addCustomerLocationContactPerson) objItem.ContactPerson = this.addCustomerLocationData.addCustomerLocationContactPerson;
            else objItem.ContactPerson = null;
            if (this.addCustomerLocationData.addCustomerLocationDesignation) objItem.Designation = this.addCustomerLocationData.addCustomerLocationDesignation;
            else objItem.Designation = null;
            if (this.addCustomerLocationData.addCustomerLocationContactNumber) objItem.PhoneNumber = this.addCustomerLocationData.addCustomerLocationContactNumber;
            else objItem.PhoneNumber = null;
            if (this.addCustomerLocationData.addCustomerLocationEmail) objItem.Email = this.addCustomerLocationData.addCustomerLocationEmail;
            else objItem.Email = null;
            console.log(objItem);
            this.addEditCustomerLocationData(objItem);
            this.isAdd = true;
        }
    }

    public autoSelectState(isEdit: boolean) {
        if (isEdit) {
            if (this.editCustomerLocationData.editCustomerLocationCityId)
                this.editCustomerLocationData.editCustomerLocationStateId = this.cityData.filter((city) => city.CityId == this.editCustomerLocationData.editCustomerLocationCityId)[0].StateId;
            // console.log(this.cityData.filter((city) => city.CityId == this.addCustomerLocationData.addCustomerLocationCityId)[0]);
        } else {
            if (this.addCustomerLocationData.addCustomerLocationCityId)
                this.addCustomerLocationData.addCustomerLocationStateId = this.cityData.filter((city) => city.CityId == this.addCustomerLocationData.addCustomerLocationCityId)[0].StateId;
        }
    }

    ExportDataInExcel() {
        this.showLoader = true;

        this._httpService.ajaxPost("CustomerLocation/ExportCustomerLocation", {
            "CustomerLocationId": 0,
            "CustomerId": this.filter.CustomerId
        }).subscribe(

            data => {
                this.reportFile = data["ReportFile"];
                window.location.href = this.reportFile;
            },
            err => {
                console.log("Export customer locations Failed");
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constants.globalError);

            },
            () => {
                this.showLoader = false;
            }
        );
    }

    AddCityFormLoad() {
        $('#resetaddCityForm').trigger('click');
    }

    ResetAddCityForm(form: any) {
        form.reset();
        form.resetForm();
        setTimeout(() => {
            this.addCityData.CityName = "";
            this.addCityData.StateId = "";
        }, 0);

        this.isAddCityFormSubmitted = false;
    }

    CancelAddCity() {
        $('#addCity').modal('hide');
    }

    public AddCity(form ? : any) {
        this.isAddCityFormSubmitted = true;
        if (!this.checkCityExists()) {
            if (form.form.valid) {
                let objItem: any = {};
                objItem.CityName = this.addCityData.CityName;
                objItem.CityId = 0;
                objItem.StateId = this.addCityData.StateId;
                this.addUpdateCityData(objItem);
            }
        }

    }


    addUpdateCityData(objItem) {
        this.showLoader = true;
        this._httpService.ajaxPost('CustomerLocation/AddUpdateCity', objItem)
            .subscribe(
                data => {

                    var msg = data["Status"].Message.split('|');
                    if (msg.length > 1) {
                        msg[0] = msg[0].toLowerCase();
                        this._sharedService.ShowMessage(data["Status"].Message);
                    } else {
                        this._sharedService.ShowMessage(data["Status"].Message);
                    }

                    if (msg[0] == "success") {
                        $('#addCity').modal('hide');
                        this.GetCityData();
                    }
                },
                err => {
                    this.showLoader = false;
                    this._sharedService.ShowMessage(this.constants.globalError);
                },
                () => {
                    this.showLoader = false;
                }
            );
    }

    filterCityList() {
        this.filteredCityList = [];
        if (this.addCityData.CityName != "" && this.addCityData.CityName != null && this.addCityData.CityName.length >= 3) {
            this.filteredCityList = this.cityData.filter(
                (city) => {
                    return city.CityName.trim().toLowerCase().substring(0, this.addCityData.CityName.length) == this.addCityData.CityName.trim().toLowerCase()
                }
            );
        }
    }

    checkCityExists(): boolean {
        this.cityExists = false;
        console.log(this.filteredCityList);
        this.filteredCityList.forEach(city => {
            if (city.CityName.toLowerCase() == this.addCityData.CityName.toLowerCase()) {
                if (city.StateId == this.addCityData.StateId)
                    this.cityExists = true;
            }
        });
        return this.cityExists;
    }


}


/** WEBPACK FOOTER **
 ** ./TypeScripts/Location/location.component.ts
 **/